import store from "@/store";
import { ServiceIds } from "@/config";

/**
 * Analytics data post function (stub for LeagueXI)
 * Can be expanded with actual analytics integration (Tealium, GA, etc.)
 */
export function utagDataPost(to, from, next) {
    const analyticsData = {
        event: "page_view",
        page_name: `leaguexi:${to.path.substring(1, to.path.length)}`,
        page_url: `${window.origin}${to.fullPath}`,
        page_title: document.title,
        user_logged_in: !!store.state.user,
        timestamp: new Date().toISOString()
    };

    // Future: Send to analytics service
    // if (typeof utag !== 'undefined') {
    //     utag.view(analyticsData);
    // }
}

export function trackEvent(eventName, eventData = {}) {
    const data = {
        event: eventName,
        user_msisdn: store.state.msisdn,
        service_id: store.state.user?.serviceId,
        timestamp: new Date().toISOString(),
        ...eventData
    };

    // Future: Send to analytics service
}

export function trackSubscription(serviceId) {
    const priceMap = {
        [ServiceIds.daily]: '5.00',
        [ServiceIds.weekly]: '20.00',
        [ServiceIds.monthly]: '35.00'
    };

    trackEvent('subscription', {
        product_name: 'LeagueXI',
        product_price: priceMap[serviceId] || '0.00',
        subscription_type: getSubscriptionType(serviceId)
    });
}

function getSubscriptionType(serviceId) {
    if (serviceId === ServiceIds.daily) return 'daily';
    if (serviceId === ServiceIds.weekly) return 'weekly';
    if (serviceId === ServiceIds.monthly) return 'monthly';
    return 'free';
}
